export const USE_COOKIES_TRUE = '?useCookies=true';
export const USE_COOKIES_FALSE = '?useCookies=false';
export const PRODUCT_PARAM = 'product';
export const SEND_EMAIL_INIT_ESPACE_ADHERENT_PARAM = 'EmailInitEA';
